import {List, Record} from 'immutable';

export interface MenuItem {
    id: string;
    title: string;
    link?: string;
    subtitle?: string;
    icon: MenuIcon;
    type: MenuItemType;
    items: List<MenuItem>;
}

export enum MenuIcon {
    Newsfeed = 'newsfeed',
    Calendar = 'calendar',
    Apps = 'apps',
    BillPayers = 'billPayers',
    Setup = 'settings',
    ChildDevelopment = 'childDevelopment',
    ActivityLibrary = 'activityLibrary',
    More = 'more',
    Messages = 'messages',
    Notifications = 'notifications',
    LogOut = 'logout',
    Collapsed = 'collapsed',
    Default = 'default',
    HelpAndSupport = 'helpAndSupport',
    // Help-menu icons (app/react/top-bar/help-menu/selectors.ts)
    INTERCOM = 'INTERCOM',
    GETTING_STARTED = 'GETTING_STARTED',
    WHATS_NEW = 'WHATS_NEW',
    HELP_CENTER = 'HELP_CENTER',
    COMMUNITY = 'COMMUNITY',
    LessonPlans = 'lessonPlans',
    Home = 'home',
    Revenue = 'revenue',
    Occupancy = 'occupancy',
    BillingActivity = 'billingActivity',
    FamlyInsights = 'famlyInsights',
    BalanceReport = 'balanceReport',
    PublicFundingReport = 'publicFundingReport',
    SettingsPage = 'SettingsPage',
    FamlyStore = 'FamlyStore',
    Account = 'Account',
}

export enum MenuItemType {
    Newsfeed = 'newsfeed',
    Calendar = 'calendar',
    Institution = 'Famly.Daycare:Institution',
    Child = 'Famly.Daycare:Child',
    Organization = 'Famly.Daycare:Organization',
    BillPayer = 'Famly.Daycare:BillPayer',
    BillPayers = 'billPayers',
    Apps = 'apps',
    FreePackageApps = 'freePackageApps',
    Setup = 'settings',
    More = 'more',
    Messages = 'messages',
    Notifications = 'notifications',
    LogOut = 'logOut',
    Collapsed = 'collapsed',
    Default = 'default',
    Common = 'common',
    HelpAndSupport = 'helpAndSupport',
    LessonPlans = 'lessonPlans',
    OrganizationSettings = 'OrganizationSettings',
    OrganizationBillingActivity = 'OrganizationBillingActivity',
    OrganizationRevenueReport = 'OrganizationRevenueReport',
    OrganizationOccupancyReport = 'OrganizationOccupancyReport',
    OrganizationPublicFundingReport = 'OrganizationPublicFundingReport',
    OrganizationBalanceReport = 'OrganizationBalanceReport',
    OrganizationInsights = 'OrganizationInsights',
    Settings = 'SettingsPage',
    FamlyStore = 'FamlyStore',
}

export class MenuItemRecord extends Record<MenuItem>({
    id: '',
    title: '',
    link: '',
    subtitle: '',
    icon: MenuIcon.Default,
    type: MenuItemType.Default,
    items: List(),
}) {}
